import { Component, Input, OnInit } from '@angular/core';
import { User } from 'src/models/user';

@Component({
    selector: 'app-body',
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.sass'],
    standalone: false
})
export class BodyComponent implements OnInit {
 isWebView: boolean= false
  @Input() isSideNavExpanded: boolean = false;
  @Input() screenWidth: number = 0;
  @Input() userProfile?: User;
  
  constructor() { }

  ngOnInit(): void {
    this.isWebView = this.ValidateWebView();
    
  }
  ValidateWebView(): boolean {
    let  dir = window.location.href;
    if(dir.toLowerCase().indexOf('/webview/') > -1)
      return false;
    else 
      return true;
  }
  getBodyClass(): string {
    let styleClass = '';
    if(this.isSideNavExpanded && this.screenWidth > 768) {
      styleClass = 'body-trimmed';
    } else if(this.isSideNavExpanded && this.screenWidth <= 768 && this.screenWidth > 0) {
      styleClass = 'body-md-screen';
    }
    return styleClass;
  }
}
